import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const AboutPage = lazy(() => import('../pages/about/page'));

// Service Pages
const WebDesignPage = lazy(() => import('../pages/services/web-design/page'));
const AIIntegrationPage = lazy(() => import('../pages/services/ai-integration/page'));
const SEOPage = lazy(() => import('../pages/services/seo/page'));
const SocialMediaPage = lazy(() => import('../pages/services/social-media/page'));
const GoogleAdsPage = lazy(() => import('../pages/services/google-ads/page'));
const ReputationManagementPage = lazy(() => import('../pages/services/reputation-management/page'));

// Industry Pages
const ElectricalPage = lazy(() => import('../pages/industries/electrical/page'));
const HVACPage = lazy(() => import('../pages/industries/hvac/page'));
const LandscapingPage = lazy(() => import('../pages/industries/landscaping/page'));
const PestControlPage = lazy(() => import('../pages/industries/pest-control/page'));
const PlumbingPage = lazy(() => import('../pages/industries/plumbing/page'));
const RoofingPage = lazy(() => import('../pages/industries/roofing/page'));

// Location Pages
const NewYorkPage = lazy(() => import('../pages/locations/new-york/page'));
const PhiladelphiaPage = lazy(() => import('../pages/locations/philadelphia/page'));
const BocaRatonPage = lazy(() => import('../pages/locations/boca-raton/page'));
const OrlandoPage = lazy(() => import('../pages/locations/orlando/page'));
const MiamiPage = lazy(() => import('../pages/locations/miami/page'));
const DallasPage = lazy(() => import('../pages/locations/dallas/page'));
const HoustonPage = lazy(() => import('../pages/locations/houston/page'));
const LosAngelesPage = lazy(() => import('../pages/locations/los-angeles/page'));
const SanDiegoPage = lazy(() => import('../pages/locations/san-diego/page'));
const AtlantaPage = lazy(() => import('../pages/locations/atlanta/page'));
const PhoenixPage = lazy(() => import('../pages/locations/phoenix/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  // Service Routes
  {
    path: '/services/web-design',
    element: <WebDesignPage />,
  },
  {
    path: '/services/ai-integration',
    element: <AIIntegrationPage />,
  },
  {
    path: '/services/seo',
    element: <SEOPage />,
  },
  {
    path: '/services/social-media',
    element: <SocialMediaPage />,
  },
  {
    path: '/services/google-ads',
    element: <GoogleAdsPage />,
  },
  {
    path: '/services/reputation-management',
    element: <ReputationManagementPage />,
  },
  // Industry Routes
  {
    path: '/industries/electrical',
    element: <ElectricalPage />,
  },
  {
    path: '/industries/hvac',
    element: <HVACPage />,
  },
  {
    path: '/industries/landscaping',
    element: <LandscapingPage />,
  },
  {
    path: '/industries/pest-control',
    element: <PestControlPage />,
  },
  {
    path: '/industries/plumbing',
    element: <PlumbingPage />,
  },
  {
    path: '/industries/roofing',
    element: <RoofingPage />,
  },
  // Location Routes
  {
    path: '/locations/new-york',
    element: <NewYorkPage />,
  },
  {
    path: '/locations/philadelphia',
    element: <PhiladelphiaPage />,
  },
  {
    path: '/locations/boca-raton',
    element: <BocaRatonPage />,
  },
  {
    path: '/locations/orlando',
    element: <OrlandoPage />,
  },
  {
    path: '/locations/miami',
    element: <MiamiPage />,
  },
  {
    path: '/locations/dallas',
    element: <DallasPage />,
  },
  {
    path: '/locations/houston',
    element: <HoustonPage />,
  },
  {
    path: '/locations/los-angeles',
    element: <LosAngelesPage />,
  },
  {
    path: '/locations/san-diego',
    element: <SanDiegoPage />,
  },
  {
    path: '/locations/atlanta',
    element: <AtlantaPage />,
  },
  {
    path: '/locations/phoenix',
    element: <PhoenixPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
